export const useUsbRead = () => {
  // 缓冲区，用于累积键盘输入
  let buf = '';
  // 回调函数引用
  let callback = null;
  // 事件处理函数引用
  let keyDownHandler = null;

  /**
   * 读取完成处理
   * @param {string} data - 读取到的数据
   */
  const onReadComplete = (data) => {
    // 去除末尾的换行符
    const cleanedData = data.replace(/[\r\n]+$/, '');
    if (!cleanedData) return;
    callback && callback(cleanedData);
  };

  /**
   * 键盘按下事件处理
   * @param {KeyboardEvent} ev - 键盘事件
   */
  const onKeyDown = (ev) => {
    // 检测回车键，提交缓冲区数据
    if (ev.key === 'Enter') {
      if (buf) {
        onReadComplete(buf);
        buf = '';
      }
      return;
    }

    // 过滤特殊键和组合键
    if (ev.key.length !== 1 || ev.ctrlKey || ev.altKey || ev.metaKey) return;
    // 累积字符到缓冲区
    buf += ev.key;
  };

  /**
   * 开始监听 USB 读卡器数据
   * @param {Function} cb - 读取成功后的回调函数，接收读取到的数据作为参数
   */
  const openUSBbRead = (cb) => {
    callback = cb;
    keyDownHandler = onKeyDown;
    document.addEventListener('keydown', keyDownHandler);
  };

  /**
   * 停止监听 USB 读卡器数据，释放资源
   */
  const closeUSBbRead = () => {
    if (keyDownHandler) {
      document.removeEventListener('keydown', keyDownHandler);
      keyDownHandler = null;
    }
    buf = '';
    callback = null;
  };

  return {
    openUSBbRead,
    closeUSBbRead
  };
};
